<!-- 料金に関する注意 -->
<template>
  <div class="column">
    <!-- 料金に関する注意 -->
    <h2 class="column-title">
      {{ $t("common.attention") }}

      <!-- MasterBook.display_price_commentを表示 -->
      <p v-html="newlineConvert(comment)"></p>
    </h2>
  </div>
</template>

<script>
export default {
  name: "MbDisplaypriceCaution",
  props: {
    comment: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  margin-top: 15px;
  .column-title {
    margin: 18px 0 5px 0;
    font-size: 15px;
    font-weight: bold;
    color: #777777;
  }

  .column-title p {
    margin: 5px 0 25px;
    font-size: 15px;
    line-height: 24px;
    color: black;
    font-weight: 100;
  }

  .column-body {
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: #ffb206;
    white-space: pre-line;
    line-height: 1.5rem;
    margin-bottom: 10px;
  }
}
</style>
